/**
 * Claim role types, status rank config, and role resolution.
 */
import { CLAIM_AUTHORITIES } from '../../constants/claimAuthorities';

export const CLAIM_STATUS_RANK = {
  CREATED: 10,
  UNDER_VERIFICATION: 20,
  RCA_PENDING: 30,
  UNDER_INVESTIGATION: 30,
  RCA_SUBMITTED: 40,
  RCA_APPROVED: 45,
  INVESTIGATED: 50,
  ACKNOWLEDGEMENT_PENDING: 60,
  ACKNOWLEDGEMENT_COMPLETED: 70,
  CLAIM_PENDING: 80,
  OPS_HOD_APPROVAL_PENDING: 85,
  SALES_HOD_APPROVAL_PENDING: 85,
  APPROVAL_PENDING: 90,
  SETTLEMENT_PENDING: 100,
  APPROVED: 110,
  REJECTED: 110,
  REVOKED: 110
};

export const claimRoleTypes = {
  CLIENT_USER: 'CLIENT_USER',
  RP_USER: 'RP_USER',
  SAM_KAM: 'SAM_KAM',
  GROUND_DEPS: 'GROUND_DEPS',
  ZOOM_CLM: 'ZOOM_CLM',
  HQ_DEPS: 'HQ_DEPS',
  CLAIM_DESK: 'CLAIM_DESK',
  HOD_DESK: 'HOD_DESK',
  OPS_HOD: 'OPS_HOD',
  SALES_HOD: 'SALES_HOD',
  FINANCE: 'FINANCE'
};

export const getClaimRole = userProfile => {
  const authorities = (userProfile && userProfile.authorities) || [];

  const AUTHORITY_TO_ROLE = [
    {
      authority: CLAIM_AUTHORITIES.CLIENT_USER,
      role: claimRoleTypes.CLIENT_USER
    },
    { authority: CLAIM_AUTHORITIES.RP_USER, role: claimRoleTypes.RP_USER },
    { authority: CLAIM_AUTHORITIES.SAM_KAM, role: claimRoleTypes.SAM_KAM },
    {
      authority: CLAIM_AUTHORITIES.GROUND_DEPS,
      role: claimRoleTypes.GROUND_DEPS
    },
    { authority: CLAIM_AUTHORITIES.ZOOM_CLM, role: claimRoleTypes.ZOOM_CLM },
    { authority: CLAIM_AUTHORITIES.CLM_RM, role: claimRoleTypes.ZOOM_CLM },
    { authority: CLAIM_AUTHORITIES.CLM, role: claimRoleTypes.ZOOM_CLM },
    { authority: CLAIM_AUTHORITIES.HQ_DEPS, role: claimRoleTypes.HQ_DEPS },
    { authority: CLAIM_AUTHORITIES.DESK, role: claimRoleTypes.CLAIM_DESK },
    { authority: CLAIM_AUTHORITIES.HOD_DESK, role: claimRoleTypes.HOD_DESK },
    { authority: CLAIM_AUTHORITIES.OPEX_HOD, role: claimRoleTypes.HOD_DESK },
    { authority: CLAIM_AUTHORITIES.OPS_HOD, role: claimRoleTypes.OPS_HOD },
    { authority: CLAIM_AUTHORITIES.SALES_HOD, role: claimRoleTypes.SALES_HOD },
    { authority: CLAIM_AUTHORITIES.FINANCE, role: claimRoleTypes.FINANCE },
    { authority: CLAIM_AUTHORITIES.FINANCE_CN, role: claimRoleTypes.FINANCE },
    { authority: CLAIM_AUTHORITIES.FINANCE_FT, role: claimRoleTypes.FINANCE }
  ];

  for (let i = 0; i < authorities.length; i += 1) {
    const match = AUTHORITY_TO_ROLE.find(m => m.authority === authorities[i]);
    if (match) return match.role;
  }

  const fallback = AUTHORITY_TO_ROLE.find(
    m => authorities.indexOf(m.authority) !== -1
  );
  if (fallback) return fallback.role;

  return null;
};

export const canCreateClaim = claimRole =>
  [
    claimRoleTypes.CLIENT_USER,
    claimRoleTypes.RP_USER,
    claimRoleTypes.SAM_KAM
  ].indexOf(claimRole) !== -1;
